import client, { CLIENT_GET_FILE } from 'api/client';
import type {
  ClaimLicenseBannerDisplayResponse,
  ClaimLicenseByUserParams,
  ClaimLicenseHistoryParams,
  ClaimLicenseHistoryResponse,
  ClaimLicenseInput,
  ClaimLicenseStateSummaryResponse,
  CreateClaimLicensesPayload,
} from 'types/claim-license';
import type { ClaimReviewerApiResponse } from 'types/user';

import { createPaginationValues, createURLParams } from 'utils/urls';

export const getClaimLicensesByUser = async ({
  pageIndex,
  pageSize,
  ...filters
}: ClaimLicenseByUserParams): Promise<ClaimReviewerApiResponse> => {
  const params = createURLParams({
    ...createPaginationValues({ pageIndex, pageSize }),
    ...filters,
  });
  const { data } = await client.get<ClaimReviewerApiResponse>(
    'license-info/claim-license/licenses-by-user/',
    { params },
  );
  return data;
};

export const getStateSummary = async (): Promise<ClaimLicenseStateSummaryResponse> => {
  const { data } = await client.get<ClaimLicenseStateSummaryResponse>(
    'license-info/claim-license/state-summary/',
  );
  return data;
};

export const createClaimLicense = async (payload: CreateClaimLicensesPayload) => {
  await client.post('license-info/claim-license/', payload);
};

export const getBannerDisplay = async (): Promise<ClaimLicenseBannerDisplayResponse> => {
  const { data } = await client.get<ClaimLicenseBannerDisplayResponse>(
    'license-info/claim-license/banner-display/',
  );
  return data;
};

export const updateClaimLicense = async (licenseId: number, payload: ClaimLicenseInput) => {
  const { data } = await client.patch(`license-info/claim-license/${licenseId}/`, payload);
  return data;
};

export const deleteClaimLicense = async (licenseId: number) => {
  await client.delete(`license-info/claim-license/${licenseId}/`);
};

export const getClaimLicenseHistory = async ({
  userId,
  ordering,
  dateFrom,
  dateTo,
  licensedState,
}: ClaimLicenseHistoryParams): Promise<ClaimLicenseHistoryResponse> => {
  const params = createURLParams({
    user_id: userId,
    ordering,
    date_from: dateFrom,
    date_to: dateTo,
    licensed_state: licensedState,
  });
  const { data } = await client.get<ClaimLicenseHistoryResponse>(
    'license-info/claim-license-history/',
    { params },
  );
  return data;
};

export const downloadClaimLicenseHistory = async ({
  userId,
  ordering,
  dateFrom,
  dateTo,
  licensedState,
}: ClaimLicenseHistoryParams): Promise<Blob> => {
  const params = createURLParams({
    user_id: userId,
    ordering,
    date_from: dateFrom,
    date_to: dateTo,
    licensed_state: licensedState,
  });
  const { data } = await CLIENT_GET_FILE.get<Blob>(
    'license-info/claim-license-history/download-csv/',
    { params },
  );
  return data;
};
